"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledContent = exports.StyledSummaryRight = exports.StyledSummaryLeft = exports.StyledSummary = exports.StyledAccordion = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
const tokens_1 = require("../../styles/tokens");
const { white } = tokens_1.COLOURS.greyscale;
const { blue } = tokens_1.COLOURS.primary;
exports.StyledAccordion = styled_components_1.default.div `
    border: ${tokens_1.BORDERS.normal.silver};
    border-radius: ${tokens_1.BORDERS.radius};
    background-color: ${white};
`;
exports.StyledSummary = styled_components_1.default.button `
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: none;
    border-radius: ${tokens_1.BORDERS.radius};
    border: ${tokens_1.BORDERS.normal.transparent};
    padding: ${tokens_1.SIZES[2]};
    width: 100%;
    transition: all 0.2s ease;

    &:hover,
    &:focus {
        background-color: ${blue[5]};
    }

    &:focus {
        border: 1px solid ${tokens_1.COLOURS.greyscale.night};
    }
`;
exports.StyledSummaryLeft = styled_components_1.default.div `
    display: flex;
    text-align: start;
    & svg {
        margin-right: ${tokens_1.SIZES[1]};
    }
`;
exports.StyledSummaryRight = styled_components_1.default.div `
    display: flex;
    align-items: center;
    transition: all 0.2s ease;
    margin-left: ${tokens_1.SIZES[1]};

    .icon-arrow {
        margin-left: ${tokens_1.SIZES[1]};
        ${({ isOpen }) => isOpen &&
    `
            transform: rotate(-180deg);
            & path {
                fill: ${blue[100]};
            }
        `}
    }
`;
exports.StyledContent = styled_components_1.default.section `
    padding: ${tokens_1.SIZES[2]}
        ${({ hasIcon }) => (hasIcon ? tokens_1.SIZES[6] : tokens_1.SIZES[2])}
        ${tokens_1.SIZES[2]};
`;
//# sourceMappingURL=Accordion.styles.js.map